/**
 * @ngdoc Filter
 * @name vrmDeviceIcon
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmTimeIntervalTextual', vrmTimeIntervalTextual);

    /* @ngInject */
    function vrmTimeIntervalTextual(locale) {
        return function (from, to, flags) {
            if (!flags) {
                flags = [];
            }
            if (!Array.isArray(flags)) {
                flags = [flags];
            }
            const shortFormat = flags.includes('short');
            const skipSeconds = flags.includes('minutes');
            const withAgo = flags.includes('ago');
            const notEmpty = flags.includes('notEmpty')

            if (to === undefined || to === null) {
                if (notEmpty) {
                    return to;
                }
                to = Math.floor(Date.now() / 1000);
            }

            let seconds = Math.abs(to - from);
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);
            let days = Math.floor(hours / 24);
            hours = hours - (days * 24);
            minutes = minutes - (days * 24 * 60) - (hours * 60);
            seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

            const parts = [];

            if (days)
                parts.push(days + (shortFormat ? "d" : (" day" + (days > 1 ? 's' : ''))));
            if (hours)
                parts.push(hours + (shortFormat ? "h" : (" hour" + (hours > 1 ? 's' : ''))));
            if (minutes || skipSeconds)
                parts.push(minutes + (shortFormat ? "m" : (" minute" + (minutes > 1 ? 's' : ''))));
            if (seconds && !skipSeconds)
                parts.push(seconds + (shortFormat ? "s" : (" second" + (seconds > 1 ? 's' : ''))));

            return  (from > to ? '-' : '') + (parts.join(", ")) + (withAgo ? ' ' + locale.getString('common.ago', {i18nFallback: 'ago'}) : '');
        };
    }

})();
